import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { timesheetTypeCounts } from "@/Constants/common";
import { _fetchTimesheetCount } from "@/services/timesheet";
const initialState = {
  isLoading: false,
  typeCount: timesheetTypeCounts,
};

export const fetchTimesheetCount = createAsyncThunk(
  "timesheets/fetchTimesheetCount",
  async (data, thunkAPI) => {
    const response = _fetchTimesheetCount(data);
    response
      .then((res) => {
        const {
          data: { result: data },
        } = res;
        let {
          total_authorised_list: authorised,
          total_submitted_list: submitted,
          total_terminated_list: terminated,
          total_assigned_list: assigned,
        } = data;
        const obj = { submitted, authorised, terminated, assigned };
        const arr = timesheetTypeCounts.map((ele) => {
          let type = ele.type;
          return {
            ...ele,
            value: obj[type] || 0,
          };
        });
        thunkAPI.dispatch(updateTypeCount(arr));
      })
      .catch((error) => {
        // handleAPICatch(error);
      })
      .finally(() => {
        // console.log('finally');
      });
  },
);

const timesheetsSlice = createSlice({
  name: "timesheets",
  initialState,
  reducers: {
    updateTypeCount: (state, action) => {
      state.typeCount = action.payload;
    },
  },
});

export const { updateTypeCount } = timesheetsSlice.actions;

export default timesheetsSlice.reducer;
